type UetQueue = {
  push: (
    command: 'event',
    eventName: 'submit_lead_form',
    params: { revenue_value: number; currency: 'GBP' }
  ) => unknown;
};

export const trackUetQuoteConversion = (eventName: string, eventParams?: Record<string, unknown>) => {
  if (typeof window === 'undefined' || eventName !== 'quote_viewed') return;

  const commission = eventParams?.value;
  if (typeof commission !== 'number' || !Number.isFinite(commission)) {
    console.error('[UET] Cannot track submit_lead_form without a finite commission value.');
    return;
  }

  const uetWindow = window as Window & { uetq?: UetQueue };
  uetWindow.uetq = uetWindow.uetq || [];
  uetWindow.uetq.push('event', 'submit_lead_form', {
    revenue_value: commission,
    currency: 'GBP',
  });
};

export const trackEvent = (eventName: string, eventParams?: Record<string, any>) => {
  trackUetQuoteConversion(eventName, eventParams);

  if (typeof window !== 'undefined' && typeof (window as any).gtag === 'function') {
    (window as any).gtag('event', eventName, eventParams);
  } else if (typeof window !== 'undefined' && (window as any).dataLayer) {
    (window as any).dataLayer.push({ event: eventName, ...eventParams });
  } else {
    console.log(`[Analytics Event] ${eventName}`, eventParams);
  }
};

export const trackPageView = (url: string) => {
  if (typeof window !== 'undefined' && typeof (window as any).gtag === 'function') {
    (window as any).gtag('config', 'G-88KRQP9RXS', {
      page_path: url,
    });
  } else if (typeof window !== 'undefined' && (window as any).dataLayer) {
    (window as any).dataLayer.push({
      event: 'pageview',
      page: url
    });
  }
};
